import React from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../../contexts/OnColorContext";
import breakpoint from "../../../../../utils/breakpoint";
import getColor from "../../../../../utils/getColor";
import space from "../../../../../utils/space";
import TextAtm from "../../../../atoms/TextAtm";
import { cssTextAtm } from "../../../../atoms/TextAtm/TextAtm.styled";
import TooltipMol from "../../../TooltipMol";
import { biggerScreenBreakpoint, cellBackground, defaultCellPaddingSpace } from "../../common";
var Subtitle = styled.p.withConfig({
  componentId: "sc-1uq7e1d-0"
})(function (_ref) {
  var $onColor = _ref.$onColor;
  return css(["", ";"], cssTextAtm({
    typography: "nano2",
    onColor: $onColor,
    emphasis: "medium"
  }));
});
var Container = styled.div.withConfig({
  componentId: "sc-1uq7e1d-1"
})(function (_ref2) {
  var $isHighlighted = _ref2.$isHighlighted,
    theme = _ref2.theme;
  return css(["display:flex;flex-basis:100%;flex-flow:column;flex-grow:1;align-items:stretch;justify-content:start;margin-bottom:", ";padding:0;text-align:left;", "{flex-basis:0;min-height:", ";margin-bottom:0;padding:", ";background:", ";}", " ", "{grid-column:1 / 3;}"], space(1), breakpoint(biggerScreenBreakpoint), space(5), space(defaultCellPaddingSpace), getColor(theme, cellBackground), $isHighlighted && css(["&:first-child{background-color:", ";border:0;}border:1px solid ", ";", "{background-color:", " !important;border:0;}"], getColor(theme, "background"), getColor(theme, "success"), breakpoint(biggerScreenBreakpoint), getColor(theme, "successLight")), Subtitle);
});
var RowLabelWrapper = styled.div.withConfig({
  componentId: "sc-1uq7e1d-2"
})(["display:grid;grid-gap:", ";grid-template-columns:auto 1fr;align-items:center;justify-items:start;", "{padding:", ";padding-left:", ";}"], space(0.5), breakpoint(biggerScreenBreakpoint), space(1), space(3));
function RowLabel(_ref3) {
  var label = _ref3.label,
    onColor = _ref3.onColor,
    isHighlighted = _ref3.isHighlighted;
  var titleTypography = "small3";
  var title;
  var subtitle;
  var tooltip;
  if (typeof label === "string") {
    title = label;
  } else {
    title = label.title;
    subtitle = label.subtitle;
    tooltip = label.tooltip;
  }
  return /*#__PURE__*/React.createElement(Container, {
    $isHighlighted: isHighlighted
  }, /*#__PURE__*/React.createElement(RowLabelWrapper, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: onColor
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: titleTypography
  }, title), tooltip ? /*#__PURE__*/React.createElement(TooltipMol, null, tooltip) : null, subtitle ? /*#__PURE__*/React.createElement(Subtitle, {
    $onColor: onColor
  }, subtitle) : null)));
}
export default RowLabel;